export const EXTERNAL_APP_BASE_URL = 'https://www.clickguard.com'
export const AFFILIATE_SIGNUP_URL = 'https://clickguard.referly.so/register'
export const AFFILIATE_LOGIN_URL = 'https://clickguard.referly.so/login'
